/**
 * Created by Qingger Corp.
 * User: yangzihua
 * Date: 2019/8/7
 * Time: 10:49
 * Desc: 分销报表
 */

import { Component, Vue, Watch } from 'vue-property-decorator';
import moment from 'moment';
import { IPSService } from '@/services/ipsServices';
import NoAuth from '@/views/components/noAuth/noAuth.vue';
import ExportFile from '@/views/components/exportFile';
import { parseSec } from '@/util';
@Component({
  components: {
    NoAuth,
    ExportFile,
  },
})
export default class CommissionStatistics extends Vue {
  /* 数据 */

  /**
   * loading状态
   * @type {boolean}
   */
  public loadingState = false;

  /**
   * 分销列表
   * @type {Array<ItemObject>}
   */
  public distributeList: Array<ItemObject> = [];

  /**
   * 页码
   * @type {number}
   */
  public page = 1;

  /**
   * 条数
   * @type {number}
   */
  public pageSize = 10;

  /**
   * 总条数
   * @type {number}
   */
  public totalCount = 0;

  /**
   * 关键字
   * @type {string}
   */
  public keywords = '';

  /**
   * 内容是否显示
   * @type {boolean}
   */
  public isContentBodyShow = false;

  public index = 0;

  /**
   * socket连接准备
   * @type {boolean}
   */

  public date = [];
  public defaultStart: Date | number;

  public defaultEnd: Date | number;
  isShowCode = false;
  actIds = [];

  get exportParams() {
    return {
      exportType: 'fxProfitReport',
      params: {
        keywords: this.keywords,
        siteIds: this.actIds,
        startOfTime: parseSec(1, this.date[0]) || '',
        endOfTime: parseSec(2, this.date[1]) || '',
      },
    };
  }

  get exportParamsDetail() {
    return {
      exportType: 'profitOut',
      params: {
        siteId: this.actIds,
        profitOutState: 9,
        order: '',
        orderBy: '',
        startTime: this.date ? parseSec(1, this.date[0]) || '' : '',
        endTime: this.date ? parseSec(2, this.date[1]) : '',
      },
    };
  }

  /* 方法 */
  /**
   * 条数变更
   * @ {number} val
   * @return null
   */
  public onSizeChange(val: number): void {
    this.page = 1;
    this.pageSize = val;
    this.getDistributeList();
  }

  /**
   * 页码变更
   * @ {number} val
   * @return null
   */
  public onPageChange(val: number): void {
    this.page = val;
    this.getDistributeList();
  }

  showInfo() {
    this.isShowCode = true;
  }

  public closeInfo(): void {
    this.isShowCode = false;
  }

  /**
   * 关键字搜索
   * @return null
   */
  public onSearchByKeyWords(): void {
    this.page = 1;
    this.pageSize = 10;
    this.getDistributeList();
  }

  public dateChange() {
    this.page = 1;
    this.getDistributeList();
  }

  public handleSelectionChange(val) {
    this.actIds = val.map((i) => {
      return +i.siteId;
    });
  }

  /**
   * 获取列表
   * @return null
   */
  public getDistributeList(): void {
    this.distributeList = [];
    const postParams = {
      page: this.page,
      pageSize: this.pageSize,
      keywords: this.keywords,
    };
    if (this.date[1] - this.date[0] > 184 * 24 * 3600 * 1000) {
      this.$message.error('提现申请时间跨度不能超过6个月！');
      this.date = [this.defaultStart, this.defaultEnd];
      (postParams['startOfTime'] = parseSec(1, this.date[0])), (postParams['endOfTime'] = parseSec(2, this.date[1]));
      IPSService.profitReportList({ postParams }).then((res) => {
        this.totalCount = res.count;
        this.distributeList = res.list;
      });
      return;
    }
    (postParams['startOfTime'] = parseSec(1, this.date[0])), (postParams['endOfTime'] = parseSec(2, this.date[1]));
    IPSService.profitReportList({ postParams }).then((res) => {
      this.totalCount = res.count;
      this.distributeList = res.list;
    });
  }
  /* 周期 */

  /**
   * 当组建创建时
   */
  public created() {
    // 权限检测
    this.isContentBodyShow = this.$store.state.authMenuCodeList.includes('VSHOP-FUNCTION-REPORT-DISTRIBUTE');
    if (this.isContentBodyShow) {
      this.defaultStart = parseSec(3);
      this.defaultEnd = parseSec(4);
      this.date = [this.defaultStart, this.defaultEnd];
      this.getDistributeList(); // 获取分销列表
    }
  }

  public goDetail(siteId, siteName, index, date) {
    const sTime = Date.parse(date[0]) / 1000 || '';
    const eTime = Date.parse(date[1]) / 1000 || '';
    date = [sTime, eTime];
    this.$router.push({ path: `/distributeBoard/info/${siteId}`, query: { siteName, index, dater: date } });
  }
}
